/**
 * The Warehouse menu's own address opens Seed Status Updation for a login holding it (RSW desk + its
 * toggle), else SLOC Updation, whose guard sends a login without a desk toggle home.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";

export const Route = createFileRoute("/_app/warehouse/")({
  beforeLoad: () => {
    const { can } = useAuth.getState();
    if (!can("warehouse.desk.raw") || !can("warehouse.seed_status"))
      throw redirect({ to: "/warehouse/sloc" });
    throw redirect({
      to: "/warehouse/$stage/seed-status",
      params: { stage: "raw" },
    });
  },
});
